import { useContext, useMemo } from 'react';
import { V3SelectedAppContext } from '../contextProviders/SplashScreenProviders/UserAndAccountProviders/V3AppsProvider';
import CurrentUserContext from '../contexts/CurrentUserContext';
import ImpersonatorContext from '../contexts/ImpersonatorContext';
import RolesContext from '../contexts/RolesContext';
import PERMISSIONS from '../permissionDefinitions';

const V3AppAdminsOnly = ({
  children,
  fallback,
}: {
  children: JSX.Element | JSX.Element[];
  fallback?: JSX.Element | JSX.Element[];
}) => {
  const { selectedWorkspace, selectedProductApp } =
    useContext(V3SelectedAppContext);
  const { id: currentUserId } = useContext(CurrentUserContext);
  const { impersonatorId } = useContext(ImpersonatorContext);
  const { currentPermissions } = useContext(RolesContext);
  const userId = useMemo(() => {
    if (impersonatorId) {
      return impersonatorId;
    }

    return currentUserId;
  }, [currentUserId, impersonatorId]);

  const app = useMemo(() => {
    if (selectedWorkspace) {
      return selectedWorkspace;
    }

    if (selectedProductApp) {
      return selectedProductApp;
    }

    return undefined;
  }, [selectedProductApp, selectedWorkspace]);

  const isAppAdmin = useMemo(() => {
    if (!app) {
      return false;
    }
    if (app.adminUserIds.includes(userId)) {
      return true;
    }

    return currentPermissions.includes(
      PERMISSIONS.CONTENT_ACCESS.VIEW_ALL_PUBLISHED,
    );
  }, [app, currentPermissions, userId]);

  if (!isAppAdmin) {
    if (fallback) {
      return <>{fallback}</>;
    }
    return null;
  }

  return <>{children}</>;
};

export default V3AppAdminsOnly;
